module.exports = __webpack_public_path__ + "img/1F1F5-1F1F8.9e768b9d.svg";